import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const AddEditTaskModal = ({
  show,
  handleClose,
  addTask,
  updateTask,
  isEditing,
  task,
  tags,
}) => {
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [deadline, setDeadline] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [priority, setPriority] = useState("");

  useEffect(() => {
    if (isEditing && task) {
      setTitle(task.title);
      setDetails(task.details);
      setDeadline(task.deadline);
      setSelectedTags(task.tags);
      setPriority(task.priority);
    } else {
      setTitle("");
      setDetails("");
      setDeadline("");
      setSelectedTags([]);
      setPriority("");
    }
  }, [isEditing, task, show]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      alert("タイトルは必須です。");
      return;
    }
    if (!priority) {
      alert("優先度を選択してください。");
      return;
    }

    const newTask = {
      id: isEditing ? task.id : Date.now().toString(),
      title: title.trim(),
      details: details.trim(),
      deadline,
      tags: selectedTags,
      priority,
      completed: isEditing ? task.completed : false,
      reminderSent: isEditing ? task.reminderSent : false,
    };

    if (isEditing) {
      updateTask(newTask);
    } else {
      addTask(newTask);
    }

    handleClose();
  };

  const handleTagChange = (e) => {
    const options = e.target.options;
    const selected = [];
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        selected.push(options[i].value);
      }
    }
    setSelectedTags(selected);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "タスクの編集" : "新規タスクの追加"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="taskTitle">
            <Form.Label>タイトル</Form.Label>
            <Form.Control
              type="text"
              placeholder="タスクのタイトル"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="taskDetails">
            <Form.Label>詳細</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="タスクの詳細"
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="taskDeadline">
            <Form.Label>締め切り日時</Form.Label>
            <Form.Control
              type="datetime-local"
              value={deadline}
              onChange={(e) => setDeadline(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="taskTag">
            <Form.Label>タグ</Form.Label>
            <Form.Control
              as="select"
              multiple
              value={selectedTags}
              onChange={handleTagChange}
            >
              {tags.map((tag) => (
                <option key={tag} value={tag}>
                  {tag}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group className="mb-3" controlId="taskPriority">
            <Form.Label>優先度</Form.Label>
            <Form.Select
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
              required
            >
              <option value="" disabled>
                選択してください
              </option>
              <option value="high">高</option>
              <option value="medium">中</option>
              <option value="low">低</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            キャンセル
          </Button>
          <Button variant="primary" type="submit">
            保存
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddEditTaskModal;
